<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="473">
    <v-row class="pr-8 pt-9 pl-9 white">
      <v-col cols="12">
        <p class="darkBluishGray--text font-weight-medium mb-12 pr-8">
          Você tem certeza que deseja excluir?
        </p>
      </v-col>
    </v-row>
    <v-row class="pb-6 pr-8 pl-9 white">
      <v-spacer />
      <v-col cols="5" sm="3" class="mr-5">
        <BaseButton
          v-html="'NÃO'"
          color="secondary"
          outlined
          width="100%"
          @click="closeModal(false)"
        />
      </v-col>
      <v-col cols="5" sm="3">
        <BaseButton
          v-html="'SIM'"
          class="secondary"
          width="100%"
          @click="closeModal(true)"
        />
      </v-col>
    </v-row>
  </v-dialog>
</template>
<script>
export default {
  methods: {
    closeModal(value) {
      this.$emit("close", value);
    }
  }
};
</script>
